var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0C1.5 0.38475 1.8675 0.75 2.25 0.75H9.75C10.1348 0.75 10.5 0.3825 10.5 0H12C12 0.596737 11.7629 1.16903 11.341 1.59099C10.919 2.01295 10.3467 2.25 9.75 2.25H6.75L6.75075 3.7965C8.20052 3.97966 9.53366 4.68549 10.5001 5.78158C11.4665 6.87767 11.9998 8.2887 12 9.75V14.25C12 14.4489 11.921 14.6397 11.7803 14.7803C11.6397 14.921 11.4489 15 11.25 15H0.75C0.551088 15 0.360322 14.921 0.21967 14.7803C0.0790178 14.6397 0 14.4489 0 14.25V9.75C2.48054e-05 8.28854 0.53339 6.87733 1.5 5.78119C2.46661 4.68505 3.80002 3.97934 5.25 3.7965V2.25H2.25C1.005 2.25 0 1.245 0 0H1.5ZM6 6.75C4.3425 6.75 3 8.0925 3 9.75C3 11.4075 4.3425 12.75 6 12.75C6.52909 12.7503 7.04885 12.6106 7.50653 12.3452C7.96421 12.0797 8.34353 11.6979 8.60598 11.2385C8.86843 10.7791 9.00469 10.2584 9.00092 9.72937C8.99714 9.20029 8.85348 8.68162 8.5845 8.226L6.53025 10.281L6.45975 10.3425C6.30901 10.4591 6.11955 10.5139 5.92986 10.4958C5.74016 10.4777 5.56446 10.3881 5.43844 10.2452C5.31241 10.1023 5.24551 9.91675 5.25133 9.72629C5.25714 9.53583 5.33524 9.35472 5.46975 9.21975L7.524 7.16475C7.06216 6.89286 6.53593 6.74964 6 6.75V6.75Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.2de36d0db25e67c4b1bc547a2f4bc936.svg";
export { ForwardRef as ReactComponent };